var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProducts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_585_5834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4484 13.2366V25.8312L12.6079 26.2514L1.68115 20.8012V7.14281L12.6079 1.67944L23.5346 7.14281V16.9138H21.8536V9.03397L13.4484 13.2366ZM12.6079 3.57061L9.4428 5.14658L17.5984 9.27036L20.8161 7.66813L12.6079 3.57061ZM11.7674 23.9531V13.2366L3.36219 9.03397V19.7506L11.7674 23.9531ZM4.3997 7.66813L12.6079 11.7656L15.7336 10.2159L7.56477 6.09216L4.3997 7.66813ZM18.4915 23.638V21.9569H26.8967V23.638H18.4915ZM18.4915 18.5949H26.8967V20.2759H18.4915V18.5949ZM15.1294 27V25.319H16.8105V27H15.1294ZM15.1294 20.2759V18.5949H16.8105V20.2759H15.1294ZM15.1294 23.638V21.9569H16.8105V23.638H15.1294ZM18.4915 27V25.319H26.8967V27H18.4915Z",
    fill: "#374B54"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_585_5834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.8966,
    height: 26.8966,
    fill: "white",
    transform: "translate(0 0.103455)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProducts);
export default __webpack_public_path__ + "static/media/products.5505f18dcca5b31f05b37f92a20e4049.svg";
export { ForwardRef as ReactComponent };